import React from "react";
import { Twitter, Instagram, Facebook, Linkedin, MessageSquare, Globe, Youtube } from "lucide-react";

const MAP = {
  x: { color: "#0f172a", label: "X", Icon: Twitter },
  twitter: { color: "#0f172a", label: "X", Icon: Twitter },
  instagram: { color: "#e1306c", label: "Instagram", Icon: Instagram },
  facebook: { color: "#1877f2", label: "Facebook", Icon: Facebook },
  linkedin: { color: "#0a66c2", label: "LinkedIn", Icon: Linkedin },
  reddit: { color: "#ff4500", label: "Reddit", Icon: MessageSquare },
  youtube: { color: "#ff0000", label: "YouTube", Icon: Youtube },
};

export default function PlatformIcon({ platform, className = "h-4 w-4" }) {
  const p = MAP[platform] || { color: "#475569", label: platform, Icon: Globe };
  const { Icon, color } = p;
  return <Icon className={className} style={{ color }} />;
}

export function platformLabel(platform) {
  return (MAP[platform] && MAP[platform].label) || platform;
}
export function platformColor(platform) {
  return (MAP[platform] && MAP[platform].color) || "#475569";
}
